import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axiosInstance from '../../axiosInstance';
import order from "../assets/order.png";
import { MenuItem, Select } from '@mui/material';

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
        maxWidth: '450px',
    },
    boxShadow:
        'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    ...theme.applyStyles('dark', {
        boxShadow:
            'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
    }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(4),
    },
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        zIndex: -1,
        inset: 0,
        backgroundImage:
            'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
        backgroundRepeat: 'no-repeat',
        ...theme.applyStyles('dark', {
            backgroundImage:
                'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
        }),
    },
}));

export default function Register() {

    const navigate = useNavigate()
    const initialValue = {
        email: "",
        password: "",
        hotel: "",
        location: "",
        type: "Restaurant",
        role: "Manager",
        description: "",
        conpassword: ""
    }
    const [data, setData] = useState(initialValue)
    const [errors, setErrors] = useState({ ...initialValue, type: "", role: "" })
    const [alert, setAlert] = useState({ show: false, message: "", type: "" })

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("password" in fieldValues) {
            temp.password =
                fieldValues.password === "" || null ? "Password is required" : "";
            const regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})");
            if (!regex.test(fieldValues.password)) {
                temp.password = "Password should be at least 8 characters and include at least one lowercase letter, one uppercase letter, one number and one special character"
            }
        }
        if ("conpassword" in fieldValues) {
            temp.conpassword =
                fieldValues.conpassword === "" || null ? "Confirm Password is required" : "";
            if (fieldValues.password !== fieldValues.conpassword) {
                temp.conpassword = "Password and Confirm Password should match"
            }
        }
        if ("hotel" in fieldValues) {
            temp.hotel =
                fieldValues.hotel === "" || null ? "Hotel Name is required" : "";
        }
        if ("location" in fieldValues) {
            temp.location =
                fieldValues.location === "" || null ? "Hotel Address is required" : "";
        }
        if ("email" in fieldValues) {
            temp.email =
                fieldValues.email === "" || null
                    ? "Email is required"
                    : /$^|.+@.+..+/.test(fieldValues.email)
                        ? ""
                        : "Invalid Email.";
        }
        setErrors({ ...temp });
        return Object.values(temp).every((x) => x === "");
    };



    const handleSubmit = () => {
        if (validate(data)) {
            axiosInstance('api/register/', {
                method: "POST",
                data: {
                    email: data.email,
                    password: data.password,
                    hotel: {
                        name: data.hotel,
                        location: data.location,
                        description: data.description
                    },
                    type: data.type,
                    role: data.role,
                }
            }).then(res => {
                window.alert("Registration Successfull. Please Login.")
                navigate("/login")
            }).catch(err => {
                const messages = Object.entries(err).map(([key, value]) => {
                    if (typeof value === 'string') {
                        return value;
                    } else if (Array.isArray(value)) {
                        return value.join(', ');
                    } else if (typeof value === 'object') {
                        return Object.entries(value).map(([k, v]) => `${k}: ${v}`).join(', ');
                    } else {
                        return '';
                    }
                }).filter(Boolean).join(', \n');
                window.alert(messages)
                // setAlert({ show: true, message: messages, type: "error" })
            })
        }
    };


    return (
        <>
            <CssBaseline enableColorScheme />
            <SignInContainer direction="column" justifyContent="space-between">
                <Card variant="outlined">
                    <img src={order} alt='order' width={"20%"} />
                    <Typography
                        variant="h4"
                        sx={{ width: '100%', }}
                    >
                        Create your account
                    </Typography>
                    <Box
                        noValidate
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            gap: 2,
                        }}
                    >
                        <FormControl>
                            <FormLabel htmlFor="email">Email *</FormLabel>
                            <TextField
                                error={errors?.email ? true : false}
                                helperText={errors?.email}
                                id="email"
                                type="email"
                                size='small'
                                name="email"
                                placeholder="your@email.com"
                                autoComplete="email"
                                autoFocus
                                required
                                fullWidth
                                variant="outlined"
                                color={errors?.email ? 'error' : 'primary'}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel id="demo-simple-select-label">Hotel Type *</FormLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="type"
                                value={data.type}
                                size='small'
                                onChange={handleChange}
                            >
                                <MenuItem value={"Restaurant"}>Restaurant</MenuItem>
                                <MenuItem value={"Hotel"}>Hotel</MenuItem>
                                <MenuItem value={"Hotel and Restaurant"}>Hotel with Restaurant</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="hotelName">Hotel Name *</FormLabel>
                            <TextField
                                error={errors?.hotel ? true : false}
                                helperText={errors?.hotel}
                                id="hotelName"
                                name="hotel"
                                placeholder="Hotel Name"
                                type="text"
                                size='small'
                                required
                                fullWidth
                                variant="outlined"
                                onChange={handleChange}
                                value={data.hotel}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="hotelAddress">Hotel Address *</FormLabel>
                            <TextField
                                error={errors?.location ? true : false}
                                helperText={errors?.location}
                                id="hotelAddress"
                                name="location"
                                placeholder="Hotel Address"
                                type="text"
                                size='small'
                                required
                                fullWidth
                                multiline
                                rows={4}
                                value={data.location}
                                variant="outlined"
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="password">Password *</FormLabel>
                            <TextField
                                error={errors?.password ? true : false}
                                helperText={errors?.password}
                                name="password"
                                placeholder="••••••"
                                type="password"
                                id="password"
                                size='small'
                                autoFocus
                                required
                                fullWidth
                                variant="outlined"
                                color={errors?.password ? 'error' : 'primary'}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl>
                            <FormLabel htmlFor="password">Confirm Password *</FormLabel>
                            <TextField
                                error={errors?.conpassword ? true : false}
                                helperText={errors?.conpassword}
                                name="conpassword"
                                placeholder="••••••"
                                type="password"
                                id="password"
                                size='small'
                                autoFocus
                                required
                                fullWidth
                                variant="outlined"
                                color={errors?.conpassword ? 'error' : 'primary'}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            onClick={handleSubmit}
                        >
                            Sign Up
                        </Button>
                    </Box>
                    <Divider>or</Divider>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography sx={{ textAlign: 'center' }}>
                            Have an account?{' '}
                            <Link
                                to="/login"
                                variant="body2"
                                sx={{ alignSelf: 'center' }}
                            >
                                Sign In
                            </Link>
                        </Typography>
                    </Box>
                </Card>
            </SignInContainer>
        </>
    );
}

